(() => {
  var I = Object.create;
  var g = Object.defineProperty;
  var x = Object.getOwnPropertyDescriptor;
  var z = Object.getOwnPropertyNames;
  var L = Object.getPrototypeOf,
    P = Object.prototype.hasOwnProperty;
  var h = (t, e) => () => {
    try {
      return (e || t((e = { exports: {} }).exports, e), e.exports);
    } catch (r) {
      throw ((e = 0), r);
    }
  };
  var A = (t, e, r, o) => {
    if ((e && typeof e == "object") || typeof e == "function")
      for (let n of z(e))
        !P.call(t, n) &&
          n !== r &&
          g(t, n, {
            get: () => e[n],
            enumerable: !(o = x(e, n)) || o.enumerable,
          });
    return t;
  };
  var y = (t, e, r) => (
    (r = t != null ? I(L(t)) : {}),
    A(
      e || !t || !t.__esModule
        ? g(r, "default", { value: t, enumerable: !0 })
        : r,
      t,
    )
  );
  var v = h((K, _) => {
    "use strict";
    function w(t) {
      try {
        let e = new URL(t);
        if (
          e.protocol !== "https:" ||
          !["bobbopet.com", "www.bobbopet.com"].includes(e.hostname) ||
          e.port ||
          e.username ||
          e.password ||
          (![
            "/",
            "/collections/all",
            "/collections/art-scratcher",
            "/collections/surfboards-scratcher",
            "/collections/rockets-scratcher",
            "/products/bobbo-bowl-cam",
            "/products/glugglug-art-scratcher",
          ].includes(e.pathname) &&
            !/^\/products\/bobbo-[a-z0-9-]{1,80}-wall-scratcher$/.test(
              e.pathname,
            )) ||
          (e.hash &&
            !/^#(?:purchase|overview|camera|app|ai|design|specs|faq|materials|patterns|specifications|wall-collection|wall-purchase|wall-overview|wall-details|wall-questions|wall-other-designs)$/.test(
              e.hash,
            ))
        )
          return !1;
        let r = new Set();
        for (let [o, n] of e.searchParams) {
          if (r.has(o)) return !1;
          if (
            (r.add(o), ["variant", "preview_theme_id", "utm_id", "campaign_id", "ad_id", "adset_id"].includes(o))
          ) {
            if (!/^\d{1,20}$/.test(n)) return !1;
          } else if (
            [
              "utm_source",
              "utm_medium",
              "utm_campaign",
              "utm_content",
              "utm_term",
              "adset_name",
              "ad_name",
              "placement",
            ].includes(o)
          ) {
            if (!/^[\p{L}\p{N}_ -]{1,100}$/u.test(n)) return !1;
          } else if (o === "fbclid") {
            if (!/^[a-zA-Z0-9_-]{1,512}$/.test(n)) return !1;
          } else if (o === "pb") {
            if (!["0", "1"].includes(n)) return !1;
          } else if (o === "country") {
            if (!/^[A-Z]{2}$/.test(n)) return !1;
          } else if (o === "page") {
            if (!/^[1-9][0-9]{0,3}$/.test(n)) return !1;
          } else if (o === "sort_by") {
            if (!["manual","best-selling","title-ascending","title-descending","price-ascending","price-descending","created-ascending","created-descending"].includes(n)) return !1;
          } else if (o === "shape") {
            if (!["all", "surfboards", "rockets", "art"].includes(n)) return !1;
          } else return !1;
        }
        return !0;
      } catch {
        return !1;
      }
    }
    function q(t, e) {
      if (t.BobboClarityGate) return t.BobboClarityGate;
      let r = "waiting",
        o = null,
        n = !1,
        l = 0,
        c = new Set(),
        a = () => {
          try {
            return (
              e.isTest !== !0 &&
              e.canSend?.() === !0 &&
              w(t.location.href) &&
              t.navigator.globalPrivacyControl !== !0
            );
          } catch {
            return !1;
          }
        };
      function i(u = "revoked") {
        if (!["revoked", "destroyed", "failed", "duplicate"].includes(r)) {
          r = u;
          for (let s of c)
            try {
              s();
            } catch {}
          if ((c.clear(), n)) {
            try {
              o.stop();
            } catch {}
            try {
              e.erase?.();
            } catch {}
          }
        }
      }
      function f(u) {
        if (r !== "active") return;
        if (!a()) {
          i();
          return;
        }
        if (typeof u != "string" || u.length > 8388608 || c.size >= 16) {
          l++;
          return;
        }
        let s,
          p = !1;
        try {
          ((s = e.transport(u, () => {
            ((p = !0), s && c.delete(s));
          })),
            typeof s == "function" && !p && c.add(s));
        } catch {}
      }
      function m() {
        if (["active", "loading"].includes(r) && !a()) {
          i();
          return;
        }
        if (r !== "waiting" || !a()) return;
        if (t.clarity) {
          r = "duplicate";
          return;
        }
        r = "loading";
        let u;
        try {
          u = e.load();
        } catch {
          i("failed");
          return;
        }
        Promise.resolve(u)
          .then((s) => {
            if (r !== "loading" || !a()) {
              r === "loading" && i();
              return;
            }
            if (
              !s ||
              ["start", "stop", "consentv2"].some(
                (p) => typeof s[p] != "function",
              )
            )
              throw Error("Unsupported SDK");
            ((o = s),
              (r = "active"),
              (n = !0),
              o.start({
                projectId: "yh3e1gnc6t",
                upload: f,
                report: null,
                track: !1,
                content: !1,
                mask: ["body"],
                unmask: [],
                drop: [
                  "form",
                  "input",
                  "textarea",
                  "select",
                  "[contenteditable]",
                ],
                fraud: !1,
                conversions: !1,
                diagnostics: !1,
                cookies: [],
                modules: [],
                lean: !1,
              }),
              o.consentv2({
                analytics_Storage: "granted",
                ad_Storage: "denied",
              }),
              o.set?.("bobbo_is_test", e.isTest === !0 ? "1" : "0"));
          })
          .catch(() => i("failed"));
      }
      let d = {
        synchronize: m,
        status: () => ({ state: r, pending: c.size, dropped: l }),
        destroy: () => i("destroyed"),
      };
      return ((t.BobboClarityGate = d), d);
    }
    _.exports = { createGate: q, safeLocation: w };
  });
  var C = h((N, S) => {
    "use strict";
    var U = "https://u.clarity.ms/collect";
    function M(t, e = () => {}, r = U) {
      if (!/^https:\/\/[a-z]\.clarity\.ms\/collect$/.test(r))
        throw Error("Invalid Clarity ingestion endpoint");
      return (o, n = () => {}) => {
        let l = new t.AbortController();
        return (
          (async () => {
            let a = o,
              i = { "Content-Type": "text/plain;charset=UTF-8" };
            if (t.CompressionStream && t.Blob && t.Response)
              try {
                let f = new t.Blob([o])
                  .stream()
                  .pipeThrough(new t.CompressionStream("gzip"));
                ((a = new Uint8Array(await new t.Response(f).arrayBuffer())),
                  (i = {
                    Accept: "application/x-clarity-gzip",
                    "Content-Type": "text/plain;charset=UTF-8",
                  }));
              } catch {}
            return l.signal.aborted
              ? null
              : t.fetch(r, {
                  method: "POST",
                  body: a,
                  headers: i,
                  credentials: "omit",
                  referrerPolicy: "no-referrer",
                  signal: l.signal,
                  keepalive: !1,
                });
          })()
            .then(
              (a) => {
                a && e(a.status);
              },
              () => e(0),
            )
            .finally(n),
          () => l.abort()
        );
      };
    }
    function R(t) {
      for (let e of ["_clck", "_clsk"])
        for (let r of [
          "",
          "bobbopet.com",
          ".bobbopet.com",
          t.location.hostname,
        ])
          t.document.cookie =
            e +
            "=; Max-Age=0; path=/; Secure; SameSite=Lax" +
            (r ? "; domain=" + r : "");
      try {
        t.sessionStorage.removeItem("_cltk");
      } catch {}
    }
    S.exports = { createTransport: M, eraseCookies: R };
  });
  var T = h((O, k) => {
    "use strict";
    function $(t, e = !1) {
      if (e === !0) return !0;
      try {
        let r = new URL(t.location.href).searchParams.get("bobbo_test");
        if (r === "0") {
          try {
            t.sessionStorage.removeItem("bobbo_measurement_qa");
          } catch {}
          return !1;
        }
        if (r === "1") {
          try {
            t.sessionStorage.setItem("bobbo_measurement_qa", "1");
          } catch {}
          return !0;
        }
        return t.sessionStorage.getItem("bobbo_measurement_qa") === "1";
      } catch {
        return !1;
      }
    }
    k.exports = { isTestVisit: $ };
  });
  var B = y(v()),
    b = y(C()),
    E = y(T());
  window.BobboMeasurementPrivacy = { safeLocation: B.safeLocation, createGate: B.createGate, isTestVisit: E.isTestVisit };
  (() => {
    if (window.BobboMeasurementBootstrap || window.Shopify?.designMode) return;
    let t = document.getElementById("bobbo-measurement-config"),
      e;
    try {
      e = JSON.parse(t?.textContent || "null");
    } catch {
      return;
    }
    if (e?.enabled !== !0) return;
    let r = (0, E.isTestVisit)(window, e.isTest === !0),
      o = window.BobboMeasurementAPI?.createCollector(window, {
        enabled: !0,
        isTest: r,
        performance: e.performance === !0,
      });
    if (!o) return;
    let n = null,
      l = null;
    e.clarity === !0 &&
      ((n = (0, B.createGate)(window, {
        canSend: () =>
          window.BobboMeasurementCore.explicitAnalyticsConsent(
            window.Shopify?.customerPrivacy,
          ),
        isTest: r,
        erase: () => (0, b.eraseCookies)(window),
        transport: (0, b.createTransport)(window),
        load: () =>
          new Promise((i, f) => {
            let m = new URL(e.clarityAsset, location.origin);
            if (
              m.protocol !== "https:" ||
              !["cdn.shopify.com", location.hostname].includes(m.hostname) ||
              !m.pathname.endsWith("/bobbo-clarity-vendor.js")
            ) {
              f(Error("Invalid SDK asset"));
              return;
            }
            let d = document.createElement("script");
            ((d.src = m.href),
              (d.async = !0),
              (d.onload = () => i(window.BobboClaritySDK)),
              (d.onerror = () => f(Error("SDK load failed"))),
              document.head.append(d));
          }),
      })),
      (l = setInterval(() => n.synchronize(), 250)),
      document.addEventListener("visitorConsentCollected", c),
      window.addEventListener("pagehide", a),
      n.synchronize());
    function c() {
      n?.synchronize();
    }
    function a() {
      n?.destroy();
    }
    window.BobboMeasurementBootstrap = {
      status: () => ({
        collector: o.diagnostics(),
        clarity: n?.status() || { state: "disabled" },
      }),
      destroy: () => {
        (clearInterval(l),
          document.removeEventListener("visitorConsentCollected", c),
          window.removeEventListener("pagehide", a),
          n?.destroy(),
          o.destroy());
      },
    };
  })();
})();
